import { render, staticRenderFns } from "./Trgi.vue?vue&type=template&id=3fb71819&scoped=true&lang=pug&"
import script from "./Trgi.vue?vue&type=script&lang=ts&"
export * from "./Trgi.vue?vue&type=script&lang=ts&"
import style0 from "./Trgi.vue?vue&type=style&index=0&id=3fb71819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb71819",
  null
  
)

export default component.exports